module.exports = __webpack_public_path__ + "img/waves2.33ae6974.jpg";